import styled from 'styled-components'
import { themeGet } from 'styled-system'
import hsTrainingHeroGraphic from 'static/img/sstep-hs-training-hero-graphic.svg'

export const EmptyMessageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1;
`

export const ParallaxIcon = styled.div`
  width: 120px;
  height: 120px;
  background-image: url(${hsTrainingHeroGraphic});
  margin-bottom: 1.5rem;
`

export const Text = styled.span`
  max-width: 390px;
  text-align: center;
  font-size: 1.125rem;
  font-family: ${themeGet('font.molde.medium')};
  color: ${themeGet('colors.darkGray')};
`
